const moment = require('moment');
const k = require('@gral/constants');
const App = require('@gral/app');

const compareObjects = (objA, objB, path = '') => {
  const keysA = objA ? Object.keys(objA) : [];
  const keysB = objB ? Object.keys(objB) : [];
  const allKeys = new Set([...keysA, ...keysB]);

  for (const key of allKeys) {
    const valueA = objA ? objA[key] : undefined;
    const valueB = objB ? objB[key] : undefined;

    const currentPath = path ? `${path}.${key}` : key;

    if (typeof valueA === 'object' && typeof valueB === 'object') {
      compareObjects(valueA, valueB, currentPath);
    } else if (valueA !== valueB) {
      console.log(`La propiedad ${currentPath} ha cambiado:`);
      console.log(`Antes: ${valueA}`);
      console.log(`Ahora: ${valueB}`);
    }
  }
};

// .this not working inside the object ???
const readSettings = function () {
  let settings = null;
  if (sessionStorage?.sessionData) {
    const sessionData = JSON.parse(sessionStorage.sessionData);
    if (sessionData) {
      // Add null check here
      ({ settings } = sessionData);
    }
  }
  return settings;
};

const getSetting = function (key) {
  const settings = readSettings();
  if (!settings) return;
  return settings[key];
};

const readUser = function () {
  let user = null;
  if (localStorage.sessionData) {
    const sessionData = JSON.parse(localStorage.sessionData);
    ({ user } = sessionData);
  }

  return user;
};

const getUser = function (key) {
  const user = readUser();
  if (!user) return;
  return user[key];
};

const createAdvancedSearchDateRangeFilterFunction = function (t) {
  return me => {
    const searchValue = me.getIn(['search', 'value']);
    let filterValue = ``;
    if (searchValue.get('$gte')) filterValue += `${t('from')} ${moment(searchValue.get('$gte')).format('DD/MM/YYYY HH:mmZ')} `;
    if (searchValue.get('$lte')) filterValue += `${t('to')} ${moment(searchValue.get('$lte')).format('DD/MM/YYYY HH:mmZ')}`;
    return filterValue;
  };
};

const helpers = {
  compareObjects,
  getDisplayId(o) {
    if (o && o.get) return o.get('customId') || o.get('logicalId') || o.get('id') || '';
    else return '';
  },
  getUserFullName(user) {
    if (user == null) {
      return '';
    }
    if (!user.get('userPersonData')) {
      return user.get('login');
    }
    return `${user.getIn(['userPersonData', 'firstName'])} ${user.getIn(['userPersonData', 'familyName'])}`;
  },
  getPersonFullName(person) {
    if (person == null) {
      return '';
    }
    if (!person.get('personData')) {
      return person.get('logicalId');
    }
    return `${person.getIn(['personData', 'firstName'])} ${person.getIn(['personData', 'familyName'])}`;
  },
  getLocationForDisplay(location) {
    if (location == null) {
      return '';
    }
    return `${location.get('site')}/${location.get('name')}`;
  },
  getAssetName(asset) {
    return this.getAssetAttr(asset, 'name');
  },
  getAssetAttr(asset, attr) {
    if (asset == null) {
      return '';
    }
    const val = asset.get(attr);
    if (val != null && val !== '') {
      return val;
    }
    return '';
  },
  getStreamNameForDisplay(stream) {
    if (stream == null) {
      return '';
    }
    return `${stream.get('name')} (element #${stream.get('elementId')})`;
  },
  currentUrlPlusQuery(attr, value) {
    return `${window.location.pathname}?${attr}=${encodeURIComponent(value)}`;
  },
  currentUrlWithoutQuery() {
    return window.location.pathname;
  },
  currentUrl() {
    return window.location.pathname + window.location.search;
  },
  isLoadingOrHasErrors(data, dataPath) {
    const rsrc = data.get(dataPath);
    if (rsrc == null) {
      return false;
    }
    if (rsrc.get('state') === k.rsrcStates.SYNCING) {
      return true;
    }
    const errors = rsrc.get('errors');
    if (errors != null ? errors.size : undefined) {
      return true;
    }
  },
  hasErrors: rsrc => rsrc.getIn(['errors', 'size']),
  getItemTypeForDisplay(itemType, fPlural) {
    let out;
    if (fPlural == null) {
      fPlural = false;
    }
    if (itemType == null) {
      return null;
    }
    switch (itemType) {
      case 'taAsset':
        if (App.fPeopleCare) {
          out = fPlural ? 'people' : 'person';
        } else {
          out = fPlural ? 'assets' : 'asset';
        }
        break;
      case 'taUser':
        if (App.fPeopleCare) {
          out = fPlural ? 'people (TA)' : 'person (TA)';
        } else {
          out = fPlural ? 'people' : 'person';
        }
        break;
      case 'taLocation':
        out = fPlural ? 'sites' : 'site';
        break;
      case 'tsElement':
        out = fPlural ? 'elements' : 'element';
        break;
      case 'tsGeometry':
        out = fPlural ? 'geometries' : 'geometry';
        break;
      default:
        itemType;
    }
    return out;
  },

  getCollectionModel(collection, id, targetIdField = 'id') {
    // if (targetIdField == null) {
    //   targetIdField = 'id';
    // }
    if (id == null) {
      return null;
    }
    if (collection == null) {
      return null;
    }
    return collection.find(o => o.get(targetIdField) === id);
  },

  iso8601ToDate(str) {
    if (str == null) {
      return null;
    }
    return moment(str).toDate();
  },

  processTimestamp(datadate, datatime) {
    if (!datadate) {
      datadate = moment();
    }
    if (!datatime) {
      datatime = moment({ hour: 0, minute: 0 });
    }

    const momentDate = moment(datadate);
    const momentTime = moment(datatime);
    const timestamp = new moment({
      year: momentDate.year(),
      month: momentDate.month(),
      day: momentDate.date(),
      hour: momentTime.hours(),
      minute: momentTime.minutes(),
    });

    return timestamp;
  },

  isValidIP(ip) {
    const regexp =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return regexp.test(ip) || ip === null || ip === '';
  },

  isValidMAC(mac) {
    const regexp = /^([0-9A-F]{2}[:]){5}([0-9A-F]{2})$/;
    const regexp2 = /^([0-9a-f]{2}[:]){5}([0-9a-f]{2})$/;
    const regexp6 = /^([0-9A-F]{2}[:]){7}([0-9A-F]{2})$/;
    const regexp62 = /^([0-9a-f]{2}[:]){7}([0-9a-f]{2})$/;
    return regexp.test(mac) || regexp2.test(mac) || regexp6.test(mac) || regexp62.test(mac) || mac === null || mac === '';
  },

  isValidURL(url) {
    const regexp = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
    return !url || regexp.test(url);
  },

  sleep(ms) {
    return new Promise((resolve, reject) => {
      // func
      if (resolve == null) {
        resolve = () => ({});
      }
      if (reject == null) {
        reject = () => ({});
      }
      return setTimeout(resolve, ms);
    });
  },

  getTextError(type, value) {
    let error = '';
    error = (() => {
      switch (type) {
        case 'ip':
          if (!this.isValidIP(value)) {
            return 'Invalid IP address';
          }
          break;
        case 'mac':
          if (!this.isValidMAC(value)) {
            return 'Invalid MAC address';
          }
          break;
        case 'url':
          if (!this.isValidURL(value)) {
            return 'Invalid URL, make sure to start with http:// or https://';
          }
          break;
      }
    })();
    return error;
  },

  handleDataTableAction(action, id, row, props) {
    return event => {
      if (!action.fnArgs) {
        action.fnArgs = {};
      }
      action.fnArgs.id = id;
      action.fnArgs.row = row;
      action.fnArgs.props = props;
      return action.fnAction(action.fnArgs);
    };
  },

  dateWithoutSeconds() {
    return moment().seconds(0).milliseconds(0).toDate();
  },

  readSettings: readSettings,
  getSetting: getSetting,
  readUser: readUser,
  getUser: getUser,

  readCustomSetting(key) {
    const setting = getSetting(key);
    if (!setting) return;
    return setting.value;
  },

  omitKeys(object /*:Immtuable Map*/) {
    // workarround until safe migration to Immutable v4 Map.deleteAll
    for (const key of KEYS_TO_OMIT) {
      object = object.remove(key);
    }
    return object;
  },

  generatePassword() {
    const pwdLength = 12;
    let result = '';
    const mayus = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const minus = 'abcdefghijklmnopqrstuvwxyz';
    const nums = '0123456789';
    const special = '!@#$%^&*';
    let characters = mayus + minus + nums + special;
    //make sure there is 1 mayus 1 minus 1 number and 1 special
    result += mayus.charAt(Math.floor(Math.random() * mayus.length));
    result += minus.charAt(Math.floor(Math.random() * minus.length));
    result += nums.charAt(Math.floor(Math.random() * nums.length));
    result += special.charAt(Math.floor(Math.random() * special.length));
    for (let i = 0; i < pwdLength - 4; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  },

  strongPasswordRegex() {
    return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
  },

  createAdvancedSearchDateRangeFilter({ searchAttr, filterDisplayName, date, type, scope }, t) {
    let searchValue;
    if (type == 'from') searchValue = { $gte: date, $lte: undefined };
    else if (type == 'to') {
      searchValue = { $gte: undefined, $lte: date };
    }

    const fnFilterValue = createAdvancedSearchDateRangeFilterFunction(t);
    return {
      search: { attr: searchAttr, value: searchValue },
      filter: { desc: filterDisplayName, fnValue: fnFilterValue },
      scope,
    };
  },

  is3dGeometry(geometryTypeId) {
    return geometryTypeId && (geometryTypeId == 'polygon3' || geometryTypeId == 'point3');
  },
  is3dGeometryPolygon(geometryTypeId) {
    return geometryTypeId && geometryTypeId == 'polygon3';
  },
  is3dGeometryPoint(geometryTypeId) {
    return geometryTypeId && geometryTypeId == 'point3';
  },
};

const KEYS_TO_OMIT = ['id', 'logicalId', '_colValues', 'createdAt', 'creatorId', 'updatedAt', 'updaterId'];

module.exports = helpers;
